<script>
import ColorPicker from '@/views/Admin/Public/ColorPicker.vue'
export default {
  props: ['colors', 'location', 'text', 'top', 'left', 'defaultColor'],
  components: {ColorPicker },
  data(){
    return {     
      color: null,   
    }
  },
  mounted() {
    this.color = this.colors.find(x => x.location == this.location);
    if(this.color == null) {
      this.color = { location: this.location, id: 0, color: this.defaultColor, font_family: '', outline: 'black' };
        this.colors.push(this.color);
    }
  },
  watch:
  {
    colors(newvalue){
        this.color = this.colors.find(x => x.location == this.location);
    }
  }
}
</script>
<template>
  <section class="opacity-admin-bg" :style="{ 'top': top, 'left': left }" v-if="color">
    <ColorPicker :color="color" :text="text"></ColorPicker>                                                           
  </section>
</template>

<style scoped>
  section {
    position:absolute;
    z-index: 10;
    border-radius: 3px;
    padding: 3px;
    background-color: rgb(115 94 80 / 85%);
  }
</style>